export var PhotoCaptureAssignmentSubTypes;
(function (PhotoCaptureAssignmentSubTypes) {
    PhotoCaptureAssignmentSubTypes["GP"] = "GP";
    PhotoCaptureAssignmentSubTypes["RP"] = "RP";
})(PhotoCaptureAssignmentSubTypes || (PhotoCaptureAssignmentSubTypes = {}));
//# sourceMappingURL=PhotoCaptureAssignmentSubTypes.js.map